import { render, staticRenderFns } from "./UserGroups.vue?vue&type=template&id=37af6b24&scoped=true"
import script from "./UserGroups.vue?vue&type=script&lang=js"
export * from "./UserGroups.vue?vue&type=script&lang=js"
import style0 from "./UserGroups.vue?vue&type=style&index=0&id=37af6b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af6b24",
  null
  
)

export default component.exports